import { axiosClient } from "@/shared/api/axios-client";
import type { Paginado } from "@/lib/types";

/**
 * Relación "clave producto/servicio SAT → centro de costo, por sociedad" · deriva el
 * centro de costo del prorrateo automático del FB60. Una clave puede tener varios
 * centros de costo en la misma sociedad; exactamente UNO por (clave, sociedad) es el
 * AUTOMÁTICO (`esAutomatico`). Paginado server-side (P42).
 */
export interface ClaveSatCentroCosto {
  id: string;
  claveSat: string;
  claveSatDescripcion: string | null;
  numeroSociedad: string;
  sociedadNombre: string;
  centroDeCostoId: string;
  centroCodigo: string;
  centroNombre: string;
  esAutomatico: boolean;
  activo: boolean;
  /** Centros de costo ACTIVOS de la misma clave y sociedad (con 1 no hay otro que elegir). */
  candidatos: number;
}

export interface CrearClaveSatCentroCostoInput {
  claveSat: string;
  numeroSociedad: string;
  centroDeCostoId: string;
}

export interface ListarClavesSatCentrosCostoParams {
  busqueda?: string;
  numeroSociedad?: string;
  page?: number;
  pageSize?: number;
}

export interface ResultadoEliminarMasivoClaveSatCentroCosto {
  eliminadas: number;
  noEncontradas: number;
}

const BASE = "/api/admin/clave-sat-centro-costo";

/** Listado PAGINADO server-side · filtros `busqueda` (contains normalizado) y `numeroSociedad`. */
export async function listarClavesSatCentrosCosto(
  params: ListarClavesSatCentrosCostoParams = {}
): Promise<Paginado<ClaveSatCentroCosto>> {
  const { data } = await axiosClient.get<Paginado<ClaveSatCentroCosto>>(BASE, { params });
  return data;
}

export async function crearClaveSatCentroCosto(input: CrearClaveSatCentroCostoInput): Promise<{ id: string }> {
  const { data } = await axiosClient.post<{ id: string }>(BASE, input);
  return data;
}

/** Elige este centro de costo como el AUTOMÁTICO de su clave y sociedad (el anterior deja de serlo). */
export async function establecerClaveSatCentroCostoAutomatico(id: string): Promise<void> {
  await axiosClient.post(`${BASE}/${id}/automatico`);
}

/** Baja lógica / reactivación · una baja pasa la bandera «automático» al siguiente por código. */
export async function cambiarEstadoClaveSatCentroCosto(id: string, activo: boolean): Promise<void> {
  await axiosClient.post(`${BASE}/${id}/estado`, { activo });
}

/** Elimina de verdad las relaciones seleccionadas (el prorrateo guarda el código del centro, no la relación). */
export async function eliminarMasivoClavesSatCentrosCosto(
  ids: string[]
): Promise<ResultadoEliminarMasivoClaveSatCentroCosto> {
  const { data } = await axiosClient.post<ResultadoEliminarMasivoClaveSatCentroCosto>(`${BASE}/eliminar-masivo`, { ids });
  return data;
}
